import { addSubCategory } from '../../../actions/siteadmin/SubCategory/addSubCategory';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';

async function submit(values, dispatch) {
	if (!values.image) {
		showToaster({ messageId: 'subCategoryImage', toasterType: 'error' });
		return;
	}

	// Blank rows are dropped here rather than in the app — an admin leaving an
	// empty input should not put an empty bullet on the service screen. An
	// all-blank list is stored as null so the app renders no checklist at all.
	const inclusions = (values.inclusions || [])
		.map((item) => (item || '').trim())
		.filter((item) => item.length > 0);

	await dispatch(
		addSubCategory(
			values.id,
			values.name,
			values.description,
			values.image,
			values.categoryId,
			values.status,
			inclusions.length ? JSON.stringify(inclusions) : null,
			(values.typicalArrival || '').trim() || null
		)
	)
}

export default submit;